import { combineReducers } from 'redux';
import { loadingStatusAccordingToReducer } from 'utils/reducers/loading-status/loading-status';
import items from './items';

const retailerReports = combineReducers({
  items,
  isLoading: loadingStatusAccordingToReducer('retailerReportsLoadingStatus'),
});

export default retailerReports;



// WEBPACK FOOTER //
// ./src/modules/retailer-reports/reducers/retailer-reports.reducer.js